import React, { useState } from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import MyButton from '../../components/MyButton';
import SearchInput from '../../components/SearchInput';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../Api';
import MyModal from '../../components/MyModal';
import useInputState from '../../helpers/hooks/useInputState';

function Notifications() {
  const navigate = useNavigate();
  const [title, setTitle, titleError, setTitleError] = useInputState('');
  const [text, setText, textError, setTextError] = useInputState('');
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalState, setModalState] = useState('');

  const validateForm = () => {
    let hasErrors = false;

    if (!title || title.trim().length < 2) {
      setTitleError('Заголовок обязателен и должен быть не менее 2 символов');
      hasErrors = true;
    } else {
      setTitleError('');
    }

    if (!text || text.trim().length < 2) {
      setTextError('Текст обязателен и должен быть не менее 2 символов');
      hasErrors = true;
    } else {
      setTextError('');
    }

    return !hasErrors;
  };

  const onSendNotification = async () => {
    if (!validateForm()) {
      return;
    }

    const data = await sendRequest({
      request: Api.sendGlobalNotification,
      payload: {
        title: title.trim(),
        text: text.trim(),
      },
      warnErrorText: 'while sending global notification',
      setLoading,
    });

    setIsModalVisible(true);
    if (data?.status !== 'ok') {
      const errorText = data?.message || 'Не удалось установить соединение с сервером.';
      setModalText(`Возникла ошибка:\n\n${errorText}`);
      setModalState('error');
    } else {
      const stats = data.statistics || {};
      const sent = stats.sent || 0;
      const skipped = stats.skipped || 0;
      const total = stats.total || 0;
      const pushSuccess = stats.push?.success || 0;
      const pushFailed = stats.push?.failed || 0;

      let statisticsText = 'Уведомление успешно отправлено!\n\n';
      statisticsText += 'Статистика отправки:\n\n';
      statisticsText += `Всего устройств: ${total}\n`;
      statisticsText += `Отправлено: ${sent}\n`;
      if (skipped > 0) {
        statisticsText += `Пропущено (уведомления отключены): ${skipped}\n`;
      }
      if (pushSuccess > 0 || pushFailed > 0) {
        statisticsText += '\nPush-уведомления:\n';
        statisticsText += `Успешно: ${pushSuccess}\n`;
        if (pushFailed > 0) {
          statisticsText += `Неудачно: ${pushFailed}\n`;
        }
      }

      setModalText(statisticsText);
      setModalState('success');
    }
  };

  const onCloseModal = () => {
    if (modalState === 'error') {
      setIsModalVisible(false);
      setTimeout(() => {
        setModalText('');
        setModalState('');
      }, 400);
    } else if (modalState === 'success') {
      setIsModalVisible(false);
      setTimeout(() => {
        setModalText('');
        setModalState('');
      }, 400);
    }

    // TODO uncomment
    setTitle('', true);
    setText('', true);
  };

  return (
    <div className="notifications">
      <PageTitle text="Уведомления (во всех странах)" />
      <div className="notifications_container">
        <div>
          <SearchInput
            wrapperClassName="notifications_input"
            placeholder="Заголовок"
            withLeftIcon={false}
            value={title}
            onChange={setTitle}
            error={titleError}
            shouldValueConsiderAsFocus={false}
          />
          <SearchInput
            wrapperClassName="notifications_input notifications_input_large"
            placeholder="Текст уведомления"
            withLeftIcon={false}
            value={text}
            onChange={setText}
            error={textError}
            isLarge
            shouldValueConsiderAsFocus={false}
          />
          <MyButton
            text="Отправить уведомление"
            onClick={onSendNotification}
            loading={loading}
            className="notifications_button"
          />
        </div>
      </div>

      <MyModal isOpen={isModalVisible} closeFunction={onCloseModal}>
        <div style={{
          padding: '20px', alignItems: 'center', display: 'flex', flexDirection: 'column',
        }}
        >
          <p style={{ whiteSpace: 'pre-wrap', marginBottom: '40px' }}>{modalText}</p>
          <MyButton
            text={modalState === 'error' ? 'Закрыть' : 'ОК'}
            onClick={onCloseModal}
          />
        </div>
      </MyModal>
    </div>
  );
}

export default Notifications;
